import type { common as en } from '@/i18n/locales/en/common';
import type { Translation } from '@/i18n/types';

export const common: Translation<typeof en> = {
  tryAgain: 'Δοκιμάστε ξανά',
  languages: {
    en: 'English',
    nl: 'Nederlands',
    de: 'Deutsch',
    fr: 'Français',
    es: 'Español',
    el: 'Ελληνικά',
    it: 'Italiano',
    pt: 'Português',
    tr: 'Türkçe',
  },
};
